export const contactInfo = {
    mailTo: "stephen@retailsystem.com",
    phone: "(650) 474-5424",
    page: "/contact",
    facebook: "",
    instagram: "",
    twitter: "",
    pinterest: "",
    youtube: "",
    linkedin: ""
}

export const contactForm = {
    fields:
    {
        name: {
            required: false,
            showInput: true
        },
        email: {
            required: false,
            showInput: true
        },
        phone: {
            required: false,
            showInput: true
        },
        storeName: {
            required: false,
            showInput: false
        },
        message: {
            required: false,
            showInput: true
        },

    }
}

export const sendAMessage = {
    title: 'Contact',
    subtitle: 'Send Us a Message',
    description: 'Leave us a comment or ask us a question and we will get back to you as quickly as possible. Please, use the contact form.',
    callUs: {
        title: 'Call Us',
        subtitle: 'Our friendly and knowledgeable staff would be delighted to help you.',
    }
}

export const storeLocations = {
    title: 'Store Locations',
    subtitle: 'If you are a furniture or mattress retailer looking for a cloud-based retail software system to help run your business more efficiently and profitably, regardless of size – don’t wait! Get in touch with us today to schedule a demonstration.',
    where: {
        title: 'WHERE WE OPERATE',
        subtitle: 'Parking lot, 2 Jordan St, Manchester M15 4PY, UK',
        urlMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.712023164871!2d-2.2527718841567297!3d53.47360658000582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb1e8a2e4a035%3A0x591184e2c4e6ab01!2sKnott%20Mill%2C%20Parking%20lot%2C%202%20Jordan%20St%2C%20Manchester%20M15%204PY%2C%20UK!5e0!3m2!1sen!2suy!4v1672185035404!5m2!1sen!2suy'
    },
    opening: {
        title: 'Opening Hours',
        subtitle: 'Monday-Friday  /  Saturday'
    }
}

export const  socialMediaMetadataInfo = {    
    urlImageSocial: '',
    urlTwitterImage: '',
}

export const showCaptcha = {
    visible: false,
    sitekey: "2ce7ad9b-d0ba-4b4a-b453-30dcdf4448ba", // (hcaptcha email= info@thewebsystem.com , password =BCEjzWCv_emg4R3)
    language: 'en'
}